<template>
  <div class="banner-container">
    <div class="sec_banner" :class="bannerList.length <= 1 ? 'hiddenSlides' : ''">
      <el-carousel
        v-if="bannerList.length > 0 || school_id == 795"
        :pause-on-hover="false"
        :interval="10000"
        :arrow="(bannerList && bannerList.length) > 1 ? 'hover' : 'never'"
        height="460px"
      >
        <el-carousel-item class="banner-item" v-if="school_id == 795">
          <div class="banner-wrapper" @click="getBannerUrl(target_type, target_url, id)">
            <video
              class="banner-img"
              muted
              autoplay
              loop
              src="https://alivideo.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/e2b43e0f0a5347e69a67f849f62c8b8c.mov"
            />
            <QueryInput v-if="school_id == 795" />
          </div>
        </el-carousel-item>
        <el-carousel-item
          class="banner-item"
          v-for="{ id, file_url, target_type, target_url } in bannerList"
          :key="id"
        >
          <div class="banner-wrapper" @click="getBannerUrl(target_type, target_url, id)">
            <img
              class="banner-img"
              :src="file_url || require('../../../assets/images/banner .png')"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
      <a v-if="!userInfo" :href="getLoginUrl()" referrerPolicy="no-referrer" class="btn-in">
        立即进入
      </a>
      <div v-else class="btn-in" @click="handleJump">立即进入</div>
    </div>
    <div class="workbench">
      <WorkBench ref="workbenchRef" :userRole="userRole" :userInfo="userInfo" />
    </div>
  </div>
</template>
<script>
import { getStorage } from '@/plugins/store'
import QueryInput from './QueryInput.vue'
import WorkBench from '@/pages/components/WorkBench.vue'
import { handleLogin, getLoginUrl } from '@/plugins/utils'

export default {
  props: {
    userRole: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    QueryInput,
    WorkBench
  },
  created() {
    this.getBanners()
    const res = getStorage('projectBaseData') || {}
    console.log(res, '2222')
    this.school_id = res.school_id
  },
  data() {
    return {
      getLoginUrl,
      bannerList: [],
      school_id: 0
    }
  },
  methods: {
    handleJump() {
      if (!this.userInfo) {
        handleLogin()
        return
      }
      const url = this.$refs.workbenchRef.onlineUrl
      if (!url) return this.$message.warning('暂无跳转链接')
      window.open(url, '_blank')
    },
    async getBanners() {
      const bannerList = await this.$http.getBannerList()
      this.bannerList = bannerList
      // this.bannerList = [{
      //   "id": "123123",
      //   "file_url": "https://image.zhihuishu.com/zhs/b2cm/base1/202408/4835f55e545d4c3d871ace6d621af9ec.png",
      //   "target_type": 0,
      //   "target_url": null
      // },]
    },
    getBannerUrl(target_type, target_url, id) {
      if (!target_url) return
      switch (target_type) {
        case 1:
        case 3:
          target_url && window.open(target_url)
          break
        case 2:
          window.location.href = `/${$schoolUrl}/bannerDetail.html?bannerCon=${id}`
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-container {
  width: 1440px;
  height: 460px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 80px;
  padding: 0 40px;
  position: relative;
  margin-bottom: 32px;
  .workbench {
    margin-left: 20px;
  }
}
.sec_banner {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  z-index: 1;
  box-sizing: border-box;
  :deep(.el-carousel__button) {
    width: 10px;
    height: 10px;
    background: #fafbfc;
    border-radius: 50%;
    opacity: 1;
  }

  :deep(.el-carousel__arrow) {
    i {
      margin-top: 4px;
    }
  }

  :deep(.el-carousel__indicator.is-active) {
    .el-carousel__button {
      width: 40px;
      height: 10px;
      background: #194189;
      border-radius: 7px;
    }
  }
  .btn-in {
    width: 148px;
    height: 45px;
    border-radius: 48px;
    position: absolute;
    left: 50%;
    top: 50%;
    background: #ffffff33;
    backdrop-filter: blur(20px);
    z-index: 2;
    font-family: PingFang SC Semibold;
    font-weight: 600;
    font-size: 20px;
    line-height: 45px;
    letter-spacing: 0%;
    text-align: center;
    color: #ffffff;
    margin-left: -74px;
    cursor: pointer;
    transition: all 1s ease;
    .btn {
      color: #ffffff;
    }
    &::before {
      content: '立即进入';
      width: 148px;
      height: 45px;
      border-radius: 48px;
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      z-index: 3;
      background: rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      opacity: 0;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
}

.banner-item {
  .banner-wrapper {
    // width: 1920px;
    width: 100%;
    height: 100%;
    // height: 100%;
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}

.sec_banner.hiddenSlides {
  :deep(.el-carousel__indicators) {
    display: none;
  }
}

.sec_banner {
  :deep(.el-carousel__indicators) {
    bottom: 48px;
    left: 160px;
    transform: inherit;
  }
}
</style>
